import React, { useState } from "react";
import { config, useFetchData } from "../utils";
import { Button, Modal, ComponentRenderer } from ".";

const getBodyListText = (bodyList) => {
  return bodyList && bodyList.length ? bodyList.join(' ') : '';
}

const WrongCredentials = ({width, breakpoint}) => {
  const { status, response } = useFetchData(config.PAGE_ID.WRONG_CREDENTIALS);
  const [show, setShow] = useState(false);
  const toggleModal = () => {
    setShow(!show);
  }

  const { headerText, buttonText, bodyList } = response;
  return (
    <ComponentRenderer status={status} response={response}>
      <React.Fragment>
        <p
          className={`${
            width > breakpoint ? "font16 lineHeight22 appendBottom25" : "font14 lineHeight16 appendBottom25"
          }`}
        >{headerText}</p>
        <p
          className={`${
            width > breakpoint ? "font16 lineHeight22" : "font14 lineHeight16"
          }`}
        >{getBodyListText(bodyList)}</p>
        <Button
          className="needHelp__wrongCredBtn"
          onClick={() => setShow(true)}
          label={buttonText}
        />
        <Modal
          show={show}
          currentModal="forgotPasswordStandalone"
          setShow={toggleModal}
        />
      </React.Fragment>
    </ComponentRenderer>
  )
}

export default WrongCredentials;
